module.exports = __webpack_public_path__ + "img/thumbnail_AsianSmallClawedOtter_f_normal.2c21958c.png";